// FAMILY-EXT: единое выпадающее меню справа в шапке.
// Сюда переехало всё, что раньше было россыпью иконок и UserStep:
// Настройки профиля, Управление пользователями (для админа),
// Переключение темы, Выход.

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Menu } from 'semantic-ui-react';
import { Popup } from '../../lib/custom-ui';

import styles from './HamburgerStep.module.scss';

const HamburgerStep = React.memo(
  ({
    isLogouting,
    isDark,
    canEditUsers,
    canEditProject,
    canEditBoard,
    onSettingsClick,
    onUsersClick,
    onProjectSettingsClick,
    onBoardSettingsClick,
    onStoragesClick,
    onThemeToggle,
    onLogout,
    onClose,
  }) => {
    const [t] = useTranslation();

    const handleSettingsClick = useCallback(() => {
      onSettingsClick();
      onClose();
    }, [onSettingsClick, onClose]);

    const handleUsersClick = useCallback(() => {
      onUsersClick();
      onClose();
    }, [onUsersClick, onClose]);

    const handleProjectSettingsClick = useCallback(() => {
      onProjectSettingsClick();
      onClose();
    }, [onProjectSettingsClick, onClose]);

    const handleBoardSettingsClick = useCallback(() => {
      onBoardSettingsClick();
      onClose();
    }, [onBoardSettingsClick, onClose]);

    // FAMILY-EXT: открытие модала внешних хранилищ
    const handleStoragesClick = useCallback(() => {
      onStoragesClick();
      onClose();
    }, [onStoragesClick, onClose]);

    const handleThemeToggle = useCallback(() => {
      onThemeToggle();
      // тему меняем мгновенно, меню оставляем открытым на 1 клик чтобы
      // пользователь видел эффект — закрытие через клик-вне
    }, [onThemeToggle]);

    let logoutMenuItemProps;
    if (isLogouting) {
      logoutMenuItemProps = {
        as: Button,
        fluid: true,
        basic: true,
        loading: true,
        disabled: true,
      };
    }

    return (
      <>
        <Popup.Header>
          {t('common.userActions', {
            context: 'title',
          })}
        </Popup.Header>
        <Popup.Content>
          <Menu secondary vertical className={styles.menu}>
            <Menu.Item className={styles.menuItem} onClick={handleSettingsClick}>
              {t('common.settings', { context: 'title' })}
            </Menu.Item>
            {canEditProject && (
              <Menu.Item className={styles.menuItem} onClick={handleProjectSettingsClick}>
                Настройки проекта
              </Menu.Item>
            )}
            {canEditBoard && (
              <Menu.Item className={styles.menuItem} onClick={handleBoardSettingsClick}>
                Настройки доски
              </Menu.Item>
            )}
            {canEditUsers && (
              <Menu.Item className={styles.menuItem} onClick={handleUsersClick}>
                {t('common.users', { context: 'title' })}
              </Menu.Item>
            )}
            {/* FAMILY-EXT: пункт открыть внешние хранилища (виден всем,
                реальные права на запись проверяет бэк) */}
            <Menu.Item className={styles.menuItem} onClick={handleStoragesClick}>
              Хранилища
            </Menu.Item>
            <Menu.Item className={styles.menuItem} onClick={handleThemeToggle}>
              {isDark ? 'Светлая тема' : 'Тёмная тема'}
            </Menu.Item>
            <Menu.Item
              {...logoutMenuItemProps} // eslint-disable-line react/jsx-props-no-spreading
              className={styles.menuItem}
              onClick={onLogout}
            >
              {t('action.logOut', { context: 'title' })}
            </Menu.Item>
          </Menu>
        </Popup.Content>
      </>
    );
  },
);

HamburgerStep.propTypes = {
  isLogouting: PropTypes.bool.isRequired,
  isDark: PropTypes.bool.isRequired,
  canEditUsers: PropTypes.bool.isRequired,
  canEditProject: PropTypes.bool,
  canEditBoard: PropTypes.bool,
  onSettingsClick: PropTypes.func.isRequired,
  onUsersClick: PropTypes.func.isRequired,
  onProjectSettingsClick: PropTypes.func,
  onBoardSettingsClick: PropTypes.func,
  onStoragesClick: PropTypes.func,
  onThemeToggle: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

HamburgerStep.defaultProps = {
  canEditProject: false,
  canEditBoard: false,
  onProjectSettingsClick: () => {},
  onBoardSettingsClick: () => {},
  onStoragesClick: () => {},
};

export default HamburgerStep;
